<template>
  <div id="questionList">
    <div class="listContainer">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="dialogVisible = true"
        size="small"
        v-if="basicsAuth.addBasicQuestion"
      >新增</el-button>
      <!-- 添加弹出对话框 -->
      <el-dialog title="新增问题" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="ruleForm.name" type="text" placeholder="这是一段问题标题表述，请尽量简洁？"></el-input>
          </el-form-item>
          <el-form-item label="问题" prop="question">
            <el-input v-model="ruleForm.question" type="text" placeholder="这是一段问题标题表述，请尽量简洁？"></el-input>
          </el-form-item>
          <el-form-item label="答案" prop="answer">
            <el-input
              v-model="ruleForm.answer"
              type="textarea"
              :autosize="{minRows:4 , maxRows:8}"
              placeholder="问题描述"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status" required>
            <el-switch class="statu" v-model="ruleForm.status" active-color="#13ce66"></el-switch>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-button @click="handleCancelDialog('ruleForm')" size="small">取 消</el-button>
            <el-button type="primary" @click="handleSubmit('ruleForm')" size="small">保 存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!--问题列表-->
      <template v-if="this.pageListData.list && this.pageListData.list.length>0">
        <el-row :gutter="20">
          <el-col
            :span="8"
            v-for="(item,index) in  this.pageListData.list.slice(0,3)"
            :key="item+index"
          >
            <div class="grid-content bg-purple" @click="EidtQuestion(item)">
              <div class="hover-recover">编辑</div>
              <div>名称：{{item.questionName}}</div>
              <div class="ques-title">问题：{{item.question}}</div>
              <p class="anwer-art">答案：{{item.answer}}</p>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="8"
            v-for="(item,index) in  this.pageListData.list.slice(3,6)"
            :key="item+index"
          >
            <div
              class="grid-content bg-purple"
              @click="EidtQuestion(item)"
              v-if="basicsAuth.updateBasicQuestionList"
            >
              <div class="hover-recover">编辑</div>
              <div>名称：{{item.questionName}}</div>
              <div class="ques-title">问题：{{item.question}}</div>
              <p class="anwer-art">答案：{{item.answer}}</p>
            </div>
          </el-col>
        </el-row>
      </template>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :page-count="pageListData.pages"
        >></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store/store";
import { genUpToken } from "./com/qiniuToken.js";
import { getPermission } from "../../api/authRequest";
import {
  addBasicQuestion,
  getBasicQuestionList,
  updateBasicQuestionList
} from "../../api/system";
export default {
  name: "questionList",
  data() {
    return {
      poupShow: false,
      dialogVisible: false,
      currentPage: 1,
      nowItemId: "",
      basicsAuth: {
        addBasicQuestion: false,
        getBasicQuestionList: false,
        updateBasicQuestionList: false
      },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        question: [
          { required: true, message: "请输入问题", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        answer: [
          { required: true, message: "请输入答案", trigger: "blur" },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur"
          }
        ]
      },
      ruleForm: {
        name:"",
        question: "",
        answer: "",
        status: true
      },
      pageListData: {}
    };
  },
  mounted() {
    this.basicsAuth.addBasicQuestion = getPermission(
      "/api/basicSetting/question/add_question_info"
    );
    this.basicsAuth.getBasicQuestionList = getPermission(
      "/api/basicSetting/question/query_question_info"
    );
    this.basicsAuth.updateBasicQuestionList = getPermission(
      "/api/basicSetting/question/update_question_info"
    );
  },
  created() {
    this.loadQuestionList();
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？").then(_ => {
        this.ruleForm = {
          question: "",
          answer: "",
          status: true
        };
        done();
      });
    },
    //分页点击事件
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadQuestionList();
    },
    EidtQuestion(item) {
      console.log(item)
      this.nowItemId = item.id;
      // 深拷贝
      let nowData = Object.assign({}, item);
      this.dialogVisible = true;
      this.ruleForm = {
        name:nowData.questionName,
        answer: nowData.answer,
        question: nowData.question,
        status: nowData.state == 1 ? true : false
      };
    },
    //取消提问
    handleCancelDialog(formName) {
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
      this.ruleForm = {
        question: "",
        answer: "",
        status: true
      };
    },
    //提交问题
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            questionName:this.ruleForm.name,
            question: this.ruleForm.question,
            answer: this.ruleForm.answer,
            state: this.ruleForm.status ? 1 : 0
          };
          if (this.nowItemId) {
            updateBasicQuestionList({ ...params, id: this.nowItemId })
              .then(res => {
                if (res.data.status == 100) {
                  this.$message({
                    message: res.data.message,
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.loadQuestionList();
                  this.$refs[formname].resetFields();
                  this.ruleForm = {
                    question: "",
                    answer: "",
                    status: true
                  };
                } else {
                  this.$message({
                    message: res.data.message,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.ruleForm = {
                  question: "",
                  answer: "",
                  status: true
                };
                console.log(error.message);
              });
          } else {
            addBasicQuestion(params)
              .then(res => {
                if (res.data.status == 100) {
                  this.$message({
                    message: res.data.message,
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.loadQuestionList();
                  this.$refs[formname].resetFields();
                  this.ruleForm = {
                    question: "",
                    answer: "",
                    status: true
                  };
                } else {
                  this.$message({
                    message: res.data.message,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.ruleForm = {
                  question: "",
                  answer: "",
                  status: true
                };
              });
          }
        } else {
          return false;
        }
      });
    },
    //获取问题列表
    loadQuestionList() {
      let params = {
        startRow: this.currentPage,
        pageSize: 6
      };
      getBasicQuestionList(params).then(res => {
        if (res.data.status == 100) {
          this.pageListData = res.data.results;
        }
      });
    }
  }
};
</script>

<style lang="scss" type="text/css" scoped>
/deep/ .el-pagination {
  text-align: right;
}
#questionList {
  .listContainer {
    .el-button {
      margin-bottom: 35px;
    }
    .el-row {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col {
      border-radius: 4px;
    }

    .bg-purple {
      background: #f3f6fb;
    }

    .grid-content {
      border-radius: 4px;
      min-height: 36px;
      padding: 15px;
      position: relative;
      cursor: pointer;
      &:hover .hover-recover {
        display: block;
      }
      .hover-recover {
        display: none;
        width: 100%;
        height: 30px;
        background: rgba(16, 197, 88, 0.5);
        text-align: center;
        color: #fff;
        line-height: 30px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 0 0 4px 4px;

        .hover-icon {
          margin: auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .ques-title{
        margin-top: 20px;
      }
      .anwer-art {
        margin-top: 20px;
        max-height: 150px;
        overflow: hidden;
        min-height: 150px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 7; /* number of lines to show */
        -webkit-box-orient: vertical;
      }
    }
    .content {
      .question-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .Q-title {
          margin-right: 15px;
        }
        .Q-input-box {
          width: 92%;
        }
      }
      .anwser-item {
        display: flex;
        .title {
          margin-right: 15px;
        }
        .input-box {
          width: 92%;
        }
      }
    }
    .switch {
      margin-top: 20px;
      .title {
        margin-right: 15px;
      }
      .statu {
      }
    }
  }
}
</style>    


// WEBPACK FOOTER //
// questionList.vue?f4462f04